import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { EnvironmentConfig } from '../../../client-config/bma-env-config';
import { CustomHttpClientService } from '../../../core/custom-http-client.service';
import { IPreCreatedBetBuilderLongList } from '../models/pre-created-bet-builder.model';

@Injectable({
    providedIn: 'root',
})
export class PreCreatedBBService {
    private readonly environment = inject(EnvironmentConfig).configuration;
    private customHttpClientService = inject(CustomHttpClientService);

    private fetchData(endpoint: string, eventId: string): Observable<IPreCreatedBetBuilderLongList> {
        return this.customHttpClientService.httpClient.get<IPreCreatedBetBuilderLongList>(
            `${this.environment.PRE_CREATED_ENDPOINT}${endpoint}/${eventId}`,
        );
    }

    public getPrecreatedBetBuildersData(eventId: string): Observable<IPreCreatedBetBuilderLongList> {
        return this.fetchData('prebetbuilders', eventId);
    }
}
